export default {
	"cityPlan": {
		"autoRouteAdd": "เพิ่มอัตโนมัติ",
		"downExcleRouterList": "ส่งออกใบตราส่งสินค้า",
		"revokeOrder": "ยกเลิก",
		"importExcleLine": "นำเข้าเส้นทาง",
		"planInMap": "ปรับเปลี่ยนบนแผนที่",
		"lineMeasure": "ระยะเส้นทาง",
		"importTips3": "นำเข้าข้อมูลกำหนดการจัดส่งโดยตรง",
		"info": "ข้อมูล",
		"autoLineResultTitle": "ผลลัพธ์ของการวางแผนเส้นทางอัตโนมัติ",
		"sucRoute": "ใบตราส่งสินค้าที่เสร็จสมบูรณ์",
		"errRoute": "ใบตราส่งสินค้าที่ยังไม่เสร็จสมบูรณ์",
		"onTimeRoute": "ตามกำหนดเวลา",
		"totalKm": "ระยะทางทั้งหมด",
		"generalCargo": "ปริมาตรทั้งหมด",
		"sectionsRoute": "การแบ่งเส้นทาง",
		"splitGoods": "การแบ่งจำนวน",
		"revokeSections": "ยกเลิกการแบ่งเส้นทาง",
		"revokeSplit": "ยกเลิกการแบ่งจำนวน",
		"modifyTime": "เวลาที่ปรับเปลี่ยน",
		"detailSplit": "ระบุรายละเอียดการแบ่ง",
		"transitInformation": "ข้อมูลระหว่างการขนส่ง",
		"transportSplit": "การแบ่งใบตราส่งสินค้า",
		"oldTransportWeight": "น้ำหนักเดิม (กก.)",
		"splitWeight": "น้ำหนักที่ถูกแบ่ง (กก.)",
		"oldTransportVolume": "ปริมาตรเดิม (ลูกบาศก์เมตร)",
		"splitVolume": "ปริมาตรที่ถูกแบ่ง (ลูกบาศก์เมตร)",
		"originalDeclaredPrice": "ราคาเดิมที่ระบุ",
		"splitOriginalDeclaredPrice": "ราคาที่ถูกแบ่ง",
		"receiptQty": "จำนวนสถานที่จัดส่งเดิม",
		"splitReceiptQty": "จำนวนสถานที่จัดส่งที่ถูกแบ่ง",
		"packingQty": "จำนวนบรรจุภัณฑ์เดิม",
		"splitPackingQty": "จำนวนบรรจุภัณฑ์ที่ถูกแบ่ง",
		"goodsQty": "ปริมาณเดิม",
		"splitGoodsQty": "ปริมาณรายการที่ถูกแบ่ง",
		"splitted":"ที่ถูกแบ่ง",
		"split": "ที่ถูกแบ่ง",
		"Tips1": "เมื่อกรอกน้ำหนัก ปริมาณที่ถูกแบ่งจะถูกระบุตามสัดส่วนโดยอัตโนมัติ",
		"Tips2": "拆出重量必须大于0或者小于原重量",
		"Tips3": "拆出体积必须大于0或者小于原体积",
		"Tips4": "拆出声明价格必须大于等于0或者小于等于原价格声明",
		"Tips5": "包装数为1不能进行拆单",
		"Tips6": "货品量为1不能进行拆单",
		"Tips7": "ค่าต้องไม่เกินจำนวนตั้งต้น",
		"IncorrectWeight":"รูปแบบนำ้หนักรวม (กิโลกรัม) ที่ถูกแบ่งไม่ถูกต้อง",
		"IncorrectVolume":"รูปแบบปริมาตรรวม (คิวบิกเมตร) ที่ถูกแบ่งไม่ถูกต้อง",
		"IncorrectDeclared":"รูปแบบมูลค่าประกันสินค้าที่ถูกแบ่งไม่ถูกต้อง",
		"IncorrectNumberOfReceipts":"รูปแบบจำนวนใบเสร็จรับเงินที่ถูกแบ่งไม่ถูกต้อง",
		"IncorrectTotalItems":"รูปแบบจำนวนสินค้าต่อบรรจุภัณฑ์ที่ถูกแบ่งไม่ถูกต้อง",
		"IncorrectTotalNumberOfPackages":"รูปแบบจำนวนบรรจุภัณฑ์ทั้งหมดที่ถูกแบ่งไม่ถูกต้อง"
	},
	"planlookCity": {
		"planlookcityTransitTitle": "การตั้งค่าสถานีขนส่งตามใบตราส่งสินค้า",
		"planlookcitySplitDetailTitle": "รายละเอียดการแบ่งเอกสาร"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/cityPlan/cityPlan.js